export { updateWaitlistTipMutation } from './updateWaitlistTipMutation';
export type {
  UpdateWaitlistTipRequest,
  UpdateWaitlistTipResponse,
} from './types';
